<div class="card" [attr.data-testid]="testId()">
  <div class="flex justify-between items-center mb-6">
    <h3 class="text-xl">{{ title() | transloco }}</h3>

    <p-selectButton
      optionValue="value"
      [options]="viewOptions"
      [allowEmpty]="false"
      [ngModel]="view()"
      [attr.data-testid]="testId() + '-view'"
      (ngModelChange)="view.set($event)"
    >
      <ng-template #item let-option>
        <span
          class="flex items-center gap-2"
          [attr.data-testid]="testId() + '-view-' + option.value"
        >
          {{ option.translationKey | transloco }}
          <i [class]="option.icon"></i>
        </span>
      </ng-template>
    </p-selectButton>
  </div>

  @if (showsTable()) {
    <div class="mt-4 overflow-x-auto" [attr.data-testid]="testId() + '-table'">
      <div class="grid gap-y-2 min-w-max" style="grid-template-columns: auto 1fr">
        @for (row of sortedRanking(); track row.id) {
          <div
            class="min-w-[60px] px-3 py-3 bg-third-level rounded-lg flex items-center justify-center mr-3"
          >
            <div class="text-sm">{{ row.identifier }}</div>
          </div>
          <div class="flex justify-between items-center p-3 bg-third-level rounded-sm">
            <span class="font-medium">{{ row.translations | translateDirectus }}</span>
            <span class="font-medium" [attr.data-testid]="testId() + '-percentage-' + row.id">
              {{ (row.percentage * 100).toFixed(2) }}%
            </span>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="mt-4 space-y-3" [attr.data-testid]="testId() + '-chart'">
      @for (bar of weightBars(); track bar.id) {
        <div class="flex items-center gap-3" [attr.data-testid]="testId() + '-bar-' + bar.id">
          <div
            class="min-w-[60px] px-3 py-2 bg-third-level rounded-lg flex items-center justify-center shrink-0"
          >
            <span class="text-sm">{{ bar.identifier }}</span>
          </div>
          <div class="flex-1 min-w-0">
            <div class="flex justify-between items-center gap-3 mb-1">
              <span class="truncate">{{ bar.translations | translateDirectus }}</span>
              <span class="font-medium shrink-0">{{ (bar.percentage * 100).toFixed(2) }}%</span>
            </div>
            <div class="h-5 w-full rounded border border-white/20 bg-third-level overflow-hidden">
              <div
                class="h-full rounded-sm"
                [style.width]="bar.width"
                [style.background-color]="bar.color"
              ></div>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>
